const renewalTransition = {
    SUBMIT_RENEWAL : 'submit renewal',

    MARK_RENEWED : 'mark renewed',

    MARK_EXPIRED : 'mark expired',

    SUBMIT_NON_RENEWAL : 'submit non-renewal',

    MARK_NON_RENEWED : 'mark non-renewed',

    RETRACT_NON_RENEWAL : 'retract non-renewal',

    FLAG_FOR_NON_RENEWAL : 'flag for non-renewal',

    CLEAR_NON_RENEWAL_FLAG : 'clear non-renewal flag'

};

angular.module('gw-um-j2js')
    .constant('renewalTransition', renewalTransition);